import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './OffersLayout.css';
import { AuctionStatusNotification } from '../../serp/components/AuctionStatusNotification';

export interface IOffersLayoutProps {
  isEmpty: boolean;
  newbuildingOffersCarousel: React.ReactNode;
  cardsWithAd: React.ReactNode;
  emptyListingBanner: React.ReactNode;
  /** Скелетоны объявлений вместо выдачи, пока она перезапрашивается */
  offersSkeleton?: React.ReactNode;
  /**
   * Показывается блок пустой выдачи: по макету отступ снизу задаёт сам блок,
   * поэтому обычный отступ обёртки убираем, иначе он складывается с ним.
   */
  isEmptyStateVisible?: boolean;
}

export const OffersLayout = React.memo<IOffersLayoutProps>(function OffersLayout({
  isEmpty,
  newbuildingOffersCarousel,
  cardsWithAd,
  emptyListingBanner,
  offersSkeleton,
  isEmptyStateVisible,
}) {
  return (
    <div className={clsx(styles['wrapper'], isEmptyStateVisible && styles['wrapper--empty-state'])} data-name="Offers">
      {isEmpty && (
        <>
          {emptyListingBanner}
          {newbuildingOffersCarousel}
        </>
      )}
      <AuctionStatusNotification />
      {offersSkeleton || cardsWithAd}
    </div>
  );
});
